// @ts-check
/** @typedef {import('../types/api').Announcement} Announcement */

import api from '../utils/apiClient';
import { assertArray } from '../utils/apiGuards';

const announcementsService = {
  /**
   * @returns {Promise<Announcement[]>}
   */
  getAll: async () => {
    const data = await api.get('/api/admin/announcements');
    assertArray(data, 'announcementsService.getAll');
    return data;
  },

  /**
   * @param {Object} data
   * @returns {Promise<Announcement>}
   */
  create: (data) => api.post('/api/admin/announcements', data),

  /**
   * @param {string} id
   * @param {Object} data
   * @returns {Promise<Announcement>}
   */
  update: (id, data) => api.patch(`/api/admin/announcements/${id}`, data),

  /**
   * @param {string} id
   * @returns {Promise<void>}
   */
  delete: (id) => api.del(`/api/admin/announcements/${id}`),

  /**
   * @param {Object[]} items
   * @returns {Promise<Object>}
   */
  reorder: (items) => api.patch('/api/admin/announcements/reorder', items),
};

export default announcementsService;
